// extracted by mini-css-extract-plugin
export var blockedMessage = "_as-3";
export var blockedOverlay = "_as-1";
export var fadeIn = "_as-2";
export var hereLink = "_as-0";
export var slideUp = "_as-4";